/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Ausstellungsdatumarbeitserlaubnis2Inputs */



/**

* @param {_Field_Ausstellungsdatumarbeitserlaubnis2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_ausstellungsdatumarbeitserlaubnis2 = /** @type {((inputs?: _Field_Ausstellungsdatumarbeitserlaubnis2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Ausstellungsdatumarbeitserlaubnis2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Ausstellungsdatum Arbeitserlaubnis")
});
export { _field_ausstellungsdatumarbeitserlaubnis2 as "_field_ausstellungsDatumArbeitserlaubnis" }